import { useEffect, useState } from "react";

/**
 * False until `delayMs` passed since the first render, then true. A component
 * that unmounts before the delay never sees true: a later mount waits again.
 */
export function useElapsed(delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setElapsed(true);
    }, delayMs);
    return () => {
      clearTimeout(id);
    };
  }, [delayMs]);

  return elapsed;
}
